'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = pagesMiddleware;

var _reactRouterRedux = require('react-router-redux');

var _actions = require('shared/components/MatchTooltip/actions');

var _config = require('config');

function pagesMiddleware(_ref) {
  var dispatch = _ref.dispatch;

  return function (next) {
    return function (action) {
      if (_config.CLIENT && action.type === _reactRouterRedux.LOCATION_CHANGE) {
        window.scrollTo(0, 0);
        dispatch((0, _actions.matchMe)(false));
      }

      return next(action);
    };
  };
} //import Api from 'shared/redux/utils/Api';

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/redux/middlewares/pages.js
// module id = 1300
// module chunks = 0